import { Component, OnInit, Output, EventEmitter, Input, OnDestroy } from '@angular/core';
import { CloverKioskSelectedItem, CloverKioskSelectedItemPayload } from '../models/clover-kiosk-models';
import { CloverKioskModelService } from 'src/app/order/services/external/clover-kiosk-model/clover-kiosk-model.service';
import { finalize, take } from 'rxjs/operators';
import { CloverKioskModel } from 'src/app/shared/models/response/clover-kiosk-model';
import { LoadingService } from 'src/app/order/services/internal/loading/loading.service';
import { DialogService } from 'src/app/order/services/internal/dialog/dialog.service';
import { Messages } from 'src/app/order/messages/order.messages';

@Component({
    selector: 'fd-clover-kiosk-item-list',
    templateUrl: './clover-kiosk-item-list.component.html',
    styleUrls: ['./clover-kiosk-item-list.component.scss'],
    standalone: false
})
export class CloverKioskItemListComponent implements OnInit, OnDestroy {
  @Input() serviceContract: number;
  @Input() cloverKioskDraftItems: CloverKioskSelectedItem[];
  @Input() maxProductAmount: number;
  @Output() itemsUpdated = new EventEmitter<CloverKioskSelectedItemPayload>();

  kioskItems: CloverKioskModel[];

  constructor(
    protected cloverKioskModelService: CloverKioskModelService,
    protected loadingService: LoadingService,
    protected dialogService: DialogService
  ) {}

  ngOnInit(): void {
    this.loadingService.adicionaLoadingEvent('getKioskModels');
    this.cloverKioskModelService
      .getByServiceContract(this.serviceContract)
      .pipe(take(1))
      .pipe(finalize(() => this.loadingService.removeLoadingEvent('getKioskModels')))
      .subscribe(
        (response) => {
          if (response?.length > 0) {
            this.kioskItems = this.setUpKioskItems(response);
            this.onQuantityChange();
          } else {
            this.dialogService.openDialog(Messages.CLOVER_KIOSK_MODELS_NOT_FOUND);
          }
        },
        (error) => {
          this.dialogService.openErrorDialog(Messages.ERROR_GET_CLOVER_KIOSK, 'Api Fiserv Online', null, null, 'error');
        }
      );
  }
  ngOnDestroy() {
    this.itemsUpdated.emit(null);
  }

  setUpKioskItems(kioskItems: CloverKioskModel[]): CloverKioskModel[] {
    return kioskItems.map((item) => {
      if (item.imageBase64) {
        item.imageBase64 = `data:image/jpeg;base64,${item.imageBase64}`;
      }
      if (item.tmsAvailable) {
         item.selectedQuantity = this.cloverKioskDraftItems?.find(kiosk => kiosk?.codeTms === item.codeTms)?.amount || 0;
      } else {
         item.selectedQuantity = 0;
      }
      return item;
    });
  }

  getAvailableOptions(currentItem: CloverKioskModel): number[] {
    const totalSelected = this.kioskItems
      .filter((item) => item.codeTms !== currentItem.codeTms)
      .reduce((acc, item) => acc + item.selectedQuantity, 0);

    const remainingLimit = this.maxProductAmount - totalSelected;
    return Array.from({ length: remainingLimit + 1 }, (_, i) => i);
  }

  onQuantityChange(): void {
    const selectedItems: CloverKioskSelectedItem[] = this.kioskItems
      .filter((i) => i.selectedQuantity > 0 && i.tmsAvailable)
      .map((item) => ({
        codeTms: item.codeTms,
        title: item.title,
        amount: item.selectedQuantity,
      }));

    const total = selectedItems.reduce((acc, item) => acc + item.amount, 0);

    const payload: CloverKioskSelectedItemPayload = {
      items: selectedItems,
      total: total,
    };

    this.itemsUpdated.emit(payload);
  }
}
